import { type ApolloError, gql } from '@apollo/react-hooks';

import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client';

export type SendAcceptanceRequest = {
  data: string;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const ACCEPT_NON_PROPOSED_INVITATION = gql`
  mutation ($input: AcceptNonProposedInvitationInput!) {
    acceptNonProposedInvitation(input: $input) {
      _id
    }
  }
`;

export const useSendAcceptanceRequest = async (
  client: ApolloClient<NormalizedCacheObject>,
  applicationId: string | undefined,
  supervisorNetId: string | undefined,
): Promise<any> => {
  const { data } = await client.mutate({
    mutation: ACCEPT_NON_PROPOSED_INVITATION,
    variables: {
      input: { applicationId, supervisorNetId },
    },
    fetchPolicy: 'network-only',
  });
  return data;
};
